import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'

export default class Modalexpercommentbacktbnforex extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",
   id_excomment:"",
   id_bn:"",
   id_ex:"",
   statuscomment_ex:"", //ผ่านหรือไม่ผ่าน
   filepdfcomment_ex:null,
   filecomment_ex:null,

}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleSubmitpass = this.handleSubmitpass.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()

 //this.props.selectex();
}

handleChangetype(event) {    this.setState({comment_bn: event.target.value});  }


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                         id_excomment:this.props.id_excomment,
                       id_bn:this.props.id_bn,
                       id_ex:this.props.id_ex,
        })
    //   this.setState({ id_bn:this.props.expert_id})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

  getExpert() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectExpert.php')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 

    }, 0);

}

handleChange(event) {    this.setState({statuscomment_ex: event.target.value});  }
 // handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({	filepdfcomment_ex: event.target.files[0]});  }
  handleChange3(event) {    this.setState({	filecomment_ex: event.target.files[0]});  }

  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.state.id_send);
      datafrm.append("id_excomment", this.state.id_excomment);
      datafrm.append("id_bn", this.state.id_bn);
      datafrm.append("id_ex", this.state.id_ex);
      datafrm.append("statuscomment_ex", this.state.statuscomment_ex);
      datafrm.append("filepdfcomment_ex", this.state.filepdfcomment_ex);
      datafrm.append("filecomment_ex", this.state.filecomment_ex);
      
  Axios.post("https://edu.kpru.ac.th/conference/PHPAPI/uploadcommentbnbackfromex.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data.status = 'success999') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })




}, 1000);

  //this.props.updateat();
 // this.toggle()
  //this.getExpert()

  }



  handleSubmitpass() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล

      datafrm.append("id_send", this.state.id_send);
      datafrm.append("id_excomment", this.state.id_excomment);
      datafrm.append("id_bn", this.state.id_bn);
      datafrm.append("id_ex", this.state.id_ex);
      datafrm.append("statuscomment_ex", this.state.statuscomment_ex);
      
  Axios.post("https://edu.kpru.ac.th/conference/PHPAPI/uploadcommentbnbackfromexpass.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data.status = 'success999') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })
}, 1000);
  }

  

    render() {
        

        return (
            <>
            <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'>อัพโหลดข้อเสนอ</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>
              อัพโหลดข้อเสนอ
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <div>

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}
               <div className="mb-2">
               <label><strong>แจ้งสถานะบทความ</strong></label>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                        <option>------กรุณาเลือกสถานะบทความ------</option>
                        <option value="1">ผ่าน</option>
                        <option value="12">ผ่านแบบมีแก้ไข</option>
                        <option value="0">ไม่ผ่าน</option>
                </select>
                </div>

              {/* <p>อัพโหลดไฟล์แบบประเมิน .word</p>
                <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}
{this.state.statuscomment_ex === '1' ?<>

</>:<>

{this.state.statuscomment_ex === '12' ?<>

<div className="mb-2">
                            <label><strong>อัพโหลดไฟล์แบบประเมินบทความ <MDBIcon icon="file-pdf" /> .word</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                    />
                     </div>

                     <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์ข้อเสนอแนะบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                     </div>



</>:<>

{this.state.statuscomment_ex === '0' ?<>
<div className="mb-2">
                            <label><strong>อัพโหลดไฟล์แบบประเมินบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                     </div>

                     <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์ข้อเสนอแนะบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                     </div>

</>:<></>}
</>}


</>}
               
                      
            
              </div>

              </MDBModalBody>

             
              <MDBModalFooter>
               
                {this.state.statuscomment_ex === '1'?<>
                <MDBBtn color="primary" onClick={this.handleSubmitpass} >บันทึก</MDBBtn>
                </>:<>
                {this.state.statuscomment_ex === '0' || this.state.statuscomment_ex === '12' ?<>
                 {this.state.filepdfcomment_ex !== null && this.state.filecomment_ex !== null  ? <> <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>  </> :<> <MDBBtn color="primary" disabled >บันทึก</MDBBtn></> }
                </>:<>
                <MDBBtn color="primary" disabled >บันทึก</MDBBtn> 
                </>}
                </>}

                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}


